 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0006 from '@/components/content/content0006'
 import CONTENTCONTENT0009 from '@/components/content/content0009'
 import CONTENTCONTENT0010 from '@/components/content/content0010'
 import CONTENTCONTENT0011 from '@/components/content/content0011'
 import CONTENTCONTENT0021 from '@/components/content/content0021'
 import CONTENTCONTENT0022 from '@/components/content/content0022'
 import CONTENTCONTENT0026 from '@/components/content/content0026'
 import CONTENTCONTENT0044 from '@/components/content/content0044'
 import CONTENTCONTENT0047 from '@/components/content/content0047'
 import CONTENTCONTENT0050 from '@/components/content/content0050'
 import CONTENTCONTENT0051 from '@/components/content/content0051'
 import CONTENTCONTENT0052 from '@/components/content/content0052'
 import CONTENTCONTENT0054 from '@/components/content/content0054'
 import CONTENTCONTENT0058 from '@/components/content/content0058'
 import CONTENTCONTENT0061 from '@/components/content/content0061'
 import CONTENTCONTENT0062 from '@/components/content/content0062'
 import CONTENTCONTENT0065 from '@/components/content/content0065'
 import CONTENTCONTENT0067 from '@/components/content/content0067'
 import CONTENTCONTENT0070 from '@/components/content/content0070'
 import CONTENTCONTENT0076 from '@/components/content/content0076'
 import CONTENTCONTENT0079 from '@/components/content/content0079'
 import CONTENTCONTENT0082 from '@/components/content/content0082'
 import CONTENTCONTENT0083 from '@/components/content/content0083'
 import CONTENTCONTENT0089 from '@/components/content/content0089'
 import CONTENTCONTENT0095 from '@/components/content/content0095'
 import CONTENTCONTENT0106 from '@/components/content/content0106'
 import CONTENTCONTENT0151 from '@/components/content/content0151'
 import CONTENTCONTENT0173 from '@/components/content/content0173'
 import CONTENTCONTENT0175 from '@/components/content/content0175'
 import CONTENTCONTENT0176 from '@/components/content/content0176'
 import CONTENTCONTENT0177 from '@/components/content/content0177'
 import CONTENTCONTENT0187 from '@/components/content/content0187'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0006",
 			"name" : "content/content0006",
 			"component" : CONTENTCONTENT0006
 		},
 		{
 			"path" : "/content/content0009",
 			"name" : "content/content0009",
 			"component" : CONTENTCONTENT0009
 		},
 		{
 			"path" : "/content/content0010",
 			"name" : "content/content0010",
 			"component" : CONTENTCONTENT0010
 		},
 		{
 			"path" : "/content/content0011",
 			"name" : "content/content0011",
 			"component" : CONTENTCONTENT0011
 		},
 		{
 			"path" : "/content/content0021",
 			"name" : "content/content0021",
 			"component" : CONTENTCONTENT0021
 		},
 		{
 			"path" : "/content/content0022",
 			"name" : "content/content0022",
 			"component" : CONTENTCONTENT0022
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js